import Dispatcher from '../Dispatcher';
import ActionTypes from './ActionTypes';

export default {
  fetch(parentType, parentId, store, username) {
    Dispatcher.dispatch({
      actionType: ActionTypes.USER_REPORT_STORE_FETCH,
      parentType,
      parentId,
      store,
      username,
    });
  }
}
